import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_APPSEBRAE}${process.env.VUE_APP_API_PATH}/appsebrae/uabs/consultorias`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/pagamentos/anexos/${pagamentoAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarPagamento(aprovaReprovaPagamentoDto) {
        return axiosJwt
            .post(`${api}/pagamentos/aprovar`, aprovaReprovaPagamentoDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(id) {
        let url = `${api}/pagamentos/${id}/exportar`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/pagamentos/${pagamentoId}/anexos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
